import React, { useState } from 'react';
import SidebarItem from './SideNavBar/SidebarItem';
import SidebarDropdown from './SideNavBar/SidebarDropdown';
import RenderSecure from '../util/RenderSecure';

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  return (
    <div className={`app-sidebar sidebar-shadow ${isSidebarOpen ? 'open' : 'closed'}`}>
      <div className="app-header__logo">
        <div className="logo-src"></div>
        <button className="hamburger close-sidebar-btn hamburger--elastic" onClick={toggleSidebar}>
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
      </div>
      <div className="scrollbar-sidebar">
        <div className="app-sidebar__inner">
          <ul className="vertical-nav-menu">
            <li className="app-sidebar__heading">School Dashboard</li>
            <SidebarItem path="/dashboard" iconClass="fa fa-home" label="Dashboard" />

            <li className="app-sidebar__heading">Applications</li>

            {/* Students Dropdown */}
            <RenderSecure code={['NEW_STUDENT', 'VIEW_STUDENTS_LIST', 'CONTACT_CENTER']}>
            <SidebarDropdown
                iconClass="fa fa-users"
                label="Students"
                basePath="/student"
                activeDropdown={activeDropdown}
                setActiveDropdown={setActiveDropdown}
                id="students"
            >
                <RenderSecure code="NEW_STUDENT">
                <SidebarItem path="/student-new" iconClass="pe-7s-less nav-icon" label="New Student" />
                </RenderSecure>
                <RenderSecure code="VIEW_STUDENTS_LIST">
                  <SidebarItem path="/student-list" iconClass="pe-7s-less nav-icon" label="Manage Students" />
                  {/* <SidebarItem path="/contact-center" iconClass="pe-7s-less nav-icon" label="Contact Center" /> */}

                </RenderSecure>
                <RenderSecure code="CONTACT_CENTER">
                <SidebarItem path="/student-contacts" iconClass="pe-7s-less nav-icon" label="Contact Center" />
                </RenderSecure>
            </SidebarDropdown>
            </RenderSecure>

            {/* Staff Dropdown */}
            <RenderSecure code={['NEW_STAFF', 'VIEW_STAFF_LIST']}>
            <SidebarDropdown
                iconClass="fa fa-briefcase"
                label="Staff"
                basePath="/staff"
                activeDropdown={activeDropdown}
                setActiveDropdown={setActiveDropdown}
                id="staff"
            >
                <RenderSecure code="NEW_STAFF">
                <SidebarItem path="/staff-new" iconClass="pe-7s-less nav-icon" label="New Staff" />
                </RenderSecure>
                <RenderSecure code="VIEW_STAFF_LIST">
                <SidebarItem path="/staff-list" iconClass="pe-7s-less nav-icon" label="List Staff" />
                </RenderSecure>
            </SidebarDropdown>
            </RenderSecure>

            {/* Academics Dropdown */}
            <RenderSecure code={['ENTER_MARKS', 'ORGANISE_MARKS', 'REPORT_CARDS_LIST', 'GENERATE_REPORT_CARDS']}>
            <SidebarDropdown
                iconClass="fa fa-book"
                label="Academics"
                basePath="/academics"
                activeDropdown={activeDropdown}
                setActiveDropdown={setActiveDropdown}
                id="academics"
            >
                <RenderSecure code="ENTER_MARKS">
                <SidebarItem path="/academics-marks-entry" iconClass="pe-7s-less nav-icon" label="Enter Marks" />
                </RenderSecure>
                <RenderSecure code="ORGANISE_MARKS">
                <SidebarItem path="/academics-marks-organise" iconClass="pe-7s-less nav-icon" label="Organise Marks" />
                </RenderSecure>
                <RenderSecure code="REPORT_CARDS_LIST">
                <SidebarItem path="/academics-reports" iconClass="pe-7s-less nav-icon" label="Report Cards" />
                </RenderSecure>
                <RenderSecure code="GENERATE_REPORT_CARDS">
                <SidebarItem path="/academics-report-view" iconClass="pe-7s-less nav-icon" label="Report Viewer" />
                </RenderSecure>
            </SidebarDropdown>
            </RenderSecure>


            <RenderSecure code="STUDENT_FEES_BALANCE">
                <SidebarItem path="/fees-balances" iconClass="fa fa-credit-card" label="Fees Balances" />
            </RenderSecure>

            {/* Settings */}
            <RenderSecure code="ORGANISE_MARKS">
              <li className="app-sidebar__heading">Tools</li>
              <SidebarItem path="/tools-transfer" iconClass="fa fa-exchange" label="Students Transfer" />
            </RenderSecure>

            {/* Settings */}
            <RenderSecure code="MANAGE_SETTINGS">
              <li className="app-sidebar__heading">System</li>
              <SidebarItem path="/settings" iconClass="fa fa-cog" label="Configurations" />
            </RenderSecure>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
